import React from "react";
import "./codesample.css";
import RightSection from "./RightSection";
import LeftSection from "./LeftSection";
function Code() {
  return (
    <div className="wrap-code">
      <div className="container">
        <div className="row">
          <div className="col-md-5">
            <LeftSection />
          </div>
          <div className="col-md-7">
            <div className="code-bg">
              <RightSection />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Code;
